const carouselItems = [
  {
    tag: '独家',
    title: '当红主播人设崩塌：幕后资本运作链浮出水面',
    subtitle: '多方信源交叉验证，揭露头部主播背后的资本推手与数据造假内幕',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20news%20studio%20with%20breaking%20news%20theme%2C%20anonymous%20figure%20in%20shadow%2C%20coral%20orange%20accent%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20high%20contrast%20chiaroscuro%2C%20suspenseful%20cinematic%20atmosphere%2C%20professional%20news%20photography&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    tag: '热榜',
    title: '顶流艺人合同纠纷升级，千万违约金背后的真相',
    subtitle: '独家获取的多份文件显示经纪公司与艺人之间长期存在的利益分配矛盾',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20legal%20document%20on%20dark%20desk%20with%20coral%20orange%20highlight%20markers%2C%20contract%20dispute%20theme%2C%20moody%20office%20lighting%2C%20professional%20investigative%20style%2C%20high%20contrast%2C%20cinematic%20composition%20with%20shadows&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    tag: '独家',
    title: '网红餐饮品牌内幕大起底：卫生问题触目惊心',
    subtitle: '暗访调查揭示多家网红餐厅后厨真实状况，监管部门已介入调查',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20restaurant%20kitchen%20scene%20with%20dramatic%20lighting%2C%20hidden%20camera%20perspective%2C%20coral%20orange%20warning%20accents%2C%20investigative%20journalism%20aesthetic%2C%20suspenseful%20mood%2C%20cinematic%20noir%20style%2C%20edgy%20editorial%20photography&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    tag: '追踪',
    title: '社会热点事件反转：被忽视的关键线索浮出水面',
    subtitle: '独家梳理事件时间线与多方说法，揭示此前被主流媒体报道忽略的重要细节',
    image: 'https://readdy.ai/api/search-image?query=Detective%20investigation%20board%20with%20red%20strings%20connecting%20photos%20and%20documents%2C%20dark%20room%20with%20coral%20orange%20task%20lighting%2C%20mystery%20solving%20theme%2C%20cinematic%20noir%20aesthetic%2C%20high%20contrast%2C%20suspenseful%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    tag: '猛料',
    title: '圈内人匿名爆料：某知名艺人团队集体出走内幕',
    subtitle: '多方消息证实幕后团队核心成员相继离职，工作室运营陷入混乱',
    image: 'https://readdy.ai/api/search-image?query=Empty%20talent%20agency%20office%20at%20night%20with%20dramatic%20shadows%2C%20abandoned%20desks%20with%20papers%2C%20coral%20orange%20exit%20sign%20glow%2C%20mysterious%20corporate%20drama%20theme%2C%20cinematic%20noir%20lighting%2C%20high%20contrast%2C%20eerie%20atmosphere&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">今日焦点专题</h2>
          <p className="text-foreground-500 text-sm mt-2">每日精选最重磅的独家爆料与深度追踪</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group relative rounded-2xl md:rounded-3xl overflow-hidden bg-background-200 aspect-[4/5] md:aspect-[3/4] block"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>
              <span className="absolute top-3 right-3 z-10 px-2.5 py-1 bg-accent-500 text-white text-xs font-semibold rounded-full">
                {item.tag}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-white font-bold text-base md:text-lg leading-tight mb-1.5">{item.title}</h3>
                <p className="text-white/60 text-xs md:text-sm">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {carouselItems.slice(3, 5).map((item, i) => (
            <a
              key={i + 3}
              href="#carousel"
              className="group relative rounded-2xl md:rounded-3xl overflow-hidden bg-background-200 aspect-[16/9] md:aspect-[2/1] block"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>
              <span className="absolute top-3 right-3 z-10 px-2.5 py-1 bg-accent-500/90 text-white text-xs font-semibold rounded-full">
                {item.tag}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-white font-bold text-base md:text-lg leading-tight mb-1.5">{item.title}</h3>
                <p className="text-white/60 text-xs md:text-sm">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}